export default "__VITE_ASSET__D005hvYZ__"